<template>
<div class="continer">
    <div class="op">
<div class="add">
  <el-input v-model="tel" size="mini" clearable placeholder="手机号"></el-input>
</div>
<div class="add">
    <el-select size="mini" clearable  v-model="state" placeholder="操作类型">
    <el-option
      v-for="item in stateList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</div>
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
<el-button type="success" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-circle-plus-outline" @click="isAdd=true;flag=false">新增</el-button>
</div>
<div class="tb">
    <el-table
    :data="tableData"
    style="width: 100%"
    stripe>
    <el-table-column
      prop="tel"
      label="手机号"
     >
    </el-table-column>
     <el-table-column
      label="用户类型"
     >
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.state==10?"都属于":scope.row.state==11?"老存钱罐":scope.row.state==12?"新存钱罐":"都不属于" }}</span>
      </template>
    </el-table-column>
      <el-table-column
      label="设备来源"
     >
      <template slot-scope="scope">
        <span style="margin-left: 10px">{{ scope.row.fromModel==1?"安卓":scope.row.fromModel==2?"苹果":"WEB" }}</span>
      </template>
    </el-table-column>
     
    <el-table-column
      prop="createTime"
      label="操作时间">
    </el-table-column>
    <el-table-column

     label="操作">
      <template slot-scope="scope">
        <el-button
        type="primary"
          size="mini"
          icon="el-icon-s-check"
          @click="handle(scope.$index, scope.row)">编辑</el-button>
           <el-button
        type="warning"
          size="mini"
          icon="el-icon-delete-solid"
          @click="del(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
</div>
<div class="rrr">
    <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
</div>
 <el-dialog title="新增" :visible.sync="isAdd">
  <el-form >
    <el-form-item label="手机号" :label-width="formLabelWidth">
      <el-input v-model="addtel" style="width:215px" size="small" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="用户类型" :label-width="formLabelWidth">
      <el-select size="small" clearable  v-model="state2" placeholder="用户类型">
    <el-option
      v-for="item in stateList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="isAdd = false">取 消</el-button>
    <el-button type="primary" @click="addrecord">确 定</el-button>
  </div>
</el-dialog>
</div>
</template>
<script>
import {formatDate} from '../../utils/datetimeYMR'
import {baseUrlPanter} from "../../utils/global";
import Axios from "axios"
import CryptoJS from 'crypto-js'
export default{
    data(){
        return{
            flag:true,
            isAdd:false,
            formLabelWidth:"200px",
            Page:1,
            totals:0,
            time:'',
            addtel:'',
            tel:"",
            d:"",
            state:'',
            state2:'',
            tableData:[],
            stateList:[{
                label:"都属于",
                value:'10'
            },{
                label:"老存钱罐",
                value:'11'
            },{
                label:"新存钱罐",
                value:'12'
            },{
                label:"都不属于",
                value:'13'
            }]
        }
    },
    methods:{
        handle(s,d){
            this.isAdd=true
            this.flag=true
            this.addtel=d.tel
            this.state2=d.state
            this.d=d
        },
        //新增
        addrecord(){
            let Url
            if(this.flag){
                Url="/update/money/user"
            }else{
                Url="/add/money/user"
            }
           
            let data={
                tel:this.addtel,
                fromModel:3,
                state:this.state2,
                id:this.d.id
            }
            Axios.get(baseUrlPanter+Url,{params: data}).then(res=>{
                console.log(res)
                if(res.data.state==200){
                    this.$message({
                        message:res.data.describe,
                        type:'success'
                    }) 
                    this.serchPage(this.Page)
                    this.isAdd=false
                }else{
                    this.$message({
                        message:res.data.describe,
                        type:'warning'
                    })
                }
            }) 
        },
        current_change(s){
            this.Page=s
        this.serchPage(s)
        },
          Encrypt(word) { //aes加密
				var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
				let srcs = CryptoJS.enc.Utf8.parse(word);
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				});
				return encrypted.toString();
			},
        serch(){
             this.serchPage(this.Page)
        },
        serchPage(s){
            let data={
                tel:this.tel,
                state:this.state,
                pageNum:s,
                pageSize:10
            }
            Axios.get(baseUrlPanter+"/web/tel/list",{params: data}).then(res=>{
                console.log(res)
                if(res.data.state==200){
                    this.tableData=res.data.result.data
                    this.totals=res.data.result.total
                }else{
                    this.$message({
                        message:res.data.describe,
                        type:'warning'
                    })
                }
            })
          
        },
        del(s,d){
        this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
             Axios.get(baseUrlPanter+"/delete/money/user",{params: {id:d.id}}).then(res=>{
                
                if(res.data.state==200){
                    this.serchPage(this.Page)
                     this.$message({
                            type: 'success',
                            message: res.data.describe
                        });
                }else{
                    this.$message({
                        message:res.data.describe,
                        type:'warning'
                    })
                }
            })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
 
        }
    },
    created(){
      this.serch()
    }

}
</script>
<style>
.continer{
    padding: 10px;
}
.op{
    display: flex
}
.add{
    margin-left: 10px
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/money.vue